import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedRoute = ({ redirectPath = "/" }) => {
  const location = useLocation();

  const isAuthenticated = localStorage.getItem("authToken");

  let hasShopifySurveyToken = false;

  if (typeof window !== "undefined") {
    const existingToken = localStorage.getItem("shopifySurveyToken");

    if (existingToken) {
      hasShopifySurveyToken = true;
    } else {
      const params = new URLSearchParams(location.search || window.location.search);
      const tokenFromQuery = params.get("token");

      if (tokenFromQuery) {
        localStorage.setItem("shopifySurveyToken", tokenFromQuery);
        hasShopifySurveyToken = true;
      }
    }
  }

  if (!isAuthenticated && !hasShopifySurveyToken) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
